import React from 'react';
import Joi from 'joi-browser';
import Form from './../common/form';
import { pwd_pattern } from './../../utils/constants';
import { resetPassword } from '../../services/authService';
import { NavLink } from 'react-router-dom';
import './css/style.scss';

class ResetPassword extends Form {
  state = {
    data: {
      username: '',
      password: '',
      new_password: '',
      confirm_password: ''
    },
    errors: {},
    complete: false
  };

  schema = {
    username: Joi.string().email().max(254).required().label('Username'),
    password: Joi.string().regex(pwd_pattern).required().label('Password'),
    new_password: Joi.string()
      .regex(pwd_pattern)
      .required()
      .label('New Password'),
    confirm_password: Joi.string()
      .regex(pwd_pattern)
      .required()
      .label('Confirm Password')
  };

  doSubmit = async () => {
    const { password, new_password, confirm_password } = this.state.data;
    let data = { ...this.state };
    try {
      if (new_password !== confirm_password) {
        data.errors.confirm_password = 'Password does not match';
        this.setState(data);
      } else {
        if (password === new_password) {
          data.errors.new_password =
            'New password should not be same as old password';
          this.setState(data);
        } else {
          await resetPassword(this.state.data);
          data.complete = true;
          this.setState(data);
        }
      }
    } catch (err) {
      const message = err.response.data.detail;
      if (message.includes('Incorrect credentials')) {
        data.errors.password = err.response.data.detail;
      } else if (message.includes('email')) {
        data.errors.username = err.response.data.detail;
      } else {
        data.errors.new_password = err.response.data.detail;
      }
      this.setState(data);
    }
  };

  render() {
    return (
      <div className='resetpassword'>
        <div className='section fadeInDown'>
          <div className='login-form-container '>
            {!this.state.complete && (
              <>
                <h4 style={{ color: 'black' }}>Reset password</h4>
                <form onSubmit={this.handleSubmit}>
                  {this.renderInput(
                    'username',
                    'Email ID',
                    'Enter your mail id',
                    'text',
                    'User'
                  )}
                  {this.renderInput(
                    'password',
                    'Old Password',
                    'Enter your last used password',
                    'password',
                    'Lock'
                  )}
                  <fieldset className='title'>
                    <legend>Change your password</legend>
                    {this.renderInput(
                      'new_password',
                      'Password',
                      'Enter your new password',
                      'password',
                      'Lock'
                    )}
                    {this.renderInput(
                      'confirm_password',
                      'Confirm Password',
                      'Confirm your new password',
                      'password',
                      'Lock'
                    )}
                  </fieldset>
                  {this.renderButton(
                    'Reset password',
                    false,
                    '100%',
                    '0.5rem 0 0'
                  )}
                </form>
              </>
            )}
            {this.state.complete && (
              <>
                <h6>Password reset successful</h6>
                <NavLink to='/login'>Click here to login again</NavLink>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
